export const LOGIN_HASH = '#!/auth/signin';

export const featureFlagData = {
    top_banner: {
        feature_name: 'top_banner',
        feature_variant: 'disabled',
        scenario_identifier: 'test top banner:3',
        for_analysis: false,
        uuid: '7dc588c1-1f5b-40ef-bbce-aaaa1d50ca41',
        player_id: '134326',
    },
    top_banner2: {
        feature_name: 'top_banner2',
        feature_variant: 'disabled',
        scenario_identifier: 'test top banner:4',
        for_analysis: true,
        uuid: '7dc588c1-1f5b-40ef-bbce-aaaa1d50ca41',
        player_id: '134326',
    },
    top_banner3: {
        feature_name: 'top_banner3',
        feature_variant: 'enabled',
        scenario_identifier: 'test top banner:5',
        for_analysis: false,
        uuid: '7dc588c1-1f5b-40ef-bbce-aaaa1d50ca41',
        player_id: '134326',
    },
    'match-list.sport-event-row-overview': {
        feature_name: 'match-list.sport-event-row-overview',
        feature_variant: 'enabled',
        scenario_identifier: 'match-list.sport-event-row-overview:0',
        for_analysis: false,
        uuid: '7dc588c1-1f5b-40ef-bbce-aaaa1d50ca41',
        player_id: '134326',
    },
    'helper.background-color': {
        feature_name: 'helper.background-color',
        feature_variant: 'blue',
        scenario_identifier: 'helper.background-color:0',
        for_analysis: false,
        uuid: '7dc588c1-1f5b-40ef-bbce-aaaa1d50ca41',
        player_id: '134326',
    },
};
